import React from "react";

const BulkSalaryUploadModal = ({
  show,
  onClose,
  onDownloadTemplate,
  onFileChange,
  onUpload,
  fileName,
}) => {
  if (!show) return null;

  const handleBackdropClick = (event) => {
    if (event.target.classList.contains("modal")) {
      onClose();
    }
  };

  return (
    <>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        onClick={handleBackdropClick}
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Bulk Salary Upload</h5>
              <button type="button" className="close" onClick={onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="text-muted">
                Download the latest salary template, fill in employee details, then upload the completed Excel.
              </p>

              <button
                type="button"
                className="btn btn-outline-primary mb-4"
                onClick={onDownloadTemplate}>
                <i className="fas fa-download mr-2"></i>
                Download Template
              </button>

              <div className="form-group">
                <label className="d-block font-weight-bold">Upload Filled Template</label>
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="bulkSalaryFile"
                    accept=".xlsx,.xls"
                    onChange={onFileChange}
                  />
                  <label className="custom-file-label" htmlFor="bulkSalaryFile">
                    {fileName || "Choose Excel file"}
                  </label>
                </div>
                <small className="form-text text-muted">
                  Supported formats: .xlsx, .xls
                </small>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={onUpload}
                disabled={!fileName}>
                <i className="fas fa-upload mr-2"></i>
                Upload Salaries
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default BulkSalaryUploadModal;
